import { Inject, Injectable } from "@angular/core";
import { getUnitInfo } from "@icc/shared/helpers/b2b";
import { TranslateService } from "@ngx-translate/core";
import { APP_CONFIG, AppConfigFactory } from "./config";

@Injectable({
    providedIn: 'root',
})
export class UnitsService {
    productUnits: Record<number, any> = {};

    constructor(
        @Inject(APP_CONFIG) private config: AppConfigFactory,
        private translateService: TranslateService,
    ) {}

    setUnits(productUnits: Record<number, any>) {
        this.productUnits = productUnits || {};
        this.updateUnitsTranslations();
    }

    getProductUnit(unitId: number) {
        return this.productUnits[unitId];
    }

    getProductUnits() {
        return this.productUnits;
    }

    getUnitInfo(unitId: number, unitCode: string) {
        if (unitId) {
            return this.productUnits[unitId];
        }
        return getUnitInfo(unitCode);
    }

    updateUnitsTranslations() {
        const unitsTranslations: any = {};
        for (const unitId in this.productUnits) {
            const unit = this.productUnits[unitId];
            unitsTranslations[unit.name] = unit.name;
            unitsTranslations[unit.symbol] = unit.symbol;
            unitsTranslations[unit.formattedName] = unit.formattedName;
        }
        this.translateService.setTranslation(this.config().CurLang, unitsTranslations, true);
    }
}
